import type { SerializableRecord } from '../model';
import { compactResolvablePageReference } from './compactResolvablePageReference';

/**
 * Strips a resolved internal page/download reference down to the slug field
 * required by `buildLinkInterface`.
 */
export function compactInternalPageReference(
  value: SerializableRecord
): SerializableRecord | undefined {
  return compactResolvablePageReference(value, 'link');
}
